$( document ).ready(function() {
	$('.menu-item-has-children').on('hover', function(e){
		e.preventDefault();
	});
	

	$('#menu-header-top-menu > li').clone().insertAfter("#main-nav > ul > li:last-child").addClass('clonedItems');
	
	const subMenus = ()=> {

		$(window).resize(function() {
			// This will fire each time the window is resized:
			if($(window).width() >= 991) {
				$('html').removeClass('nav-toggled subnav-showing');
			} else {
				// if smaller
				// Sub menu revealing on mobile
				$('.menu-item-has-children').on('touchstart click', function(event) {
					event.preventDefault();
					var $parent = $(this);
					var $submenu = $parent.children('.sub-menu');
					$submenu.addClass('is-visible');
					$('html').addClass('subnav-showing');
					$submenu.css({'opacity' : '1', 'visibility': 'visible'});
			
					// clone nav item in sub menu after back button
					if ($('.menu-item-has-children').children('ul').length > 0){
						console.log('ok');
						var myLi = $(this).children('a')[0].outerHTML;
						$('.menu-item-cloned').remove();
						$(this).children('ul').find('.btnback').after('<li class="menu-item-cloned">' + myLi + '</li>');
					}
				});
			}
		}).resize(); // This will simulate a resize to trigger the initial run.
		
	
		// Add click events to submenu links.
		$('.sub-menu li').on('touchstart click', function(){
			var linkClick = $(this).children('a').attr('href');
			if($(this).children('ul').length < 1){
				window.location.href = linkClick;
			}
		});
	
		// Bind new click event on appended element.
		$(".sub-menu").on("touchstart click", ".menu-item-cloned", function(){
			var linkClick = $(this).children('.menu-item-cloned a').attr('href');
			window.location.href = linkClick;
		});
	
		// Hide subnav.
		$('body').on('touchstart click', '.js-backsubmenu', function(event) {
			event.preventDefault();
			hideSubNav();
		});
	
		// Remove default mouseover animation from parent theme.
		$('.menu-item-has-children').on('mouseover', function(e){
			e.preventDefault();
		});
	
		// Add back button to the top of each sub nav menu
		$('.main-nav .sub-menu').prepend('<li class="btnback js-backsubmenu"><a href="/">Back</a></li>');
		
	
	}
	
	const hideSubNav = ()=> {
	  $('.sub-menu').removeClass('is-visible');
		$('html').removeClass('subnav-showing');
	}
	
	const toggleNav = ($el) => {
	  const $html = $('html');
		if (!$el.hasClass('is-active')) {
			$el.addClass('is-active');
			$html.addClass('nav-toggled');
			$('.togglenav__text').text('Close');
		} else {
			$el.removeClass('is-active');
			$html.removeClass('nav-toggled');
			$('.togglenav__text').text('Menu');
			// Reset sub menus on mobile
			hideSubNav();
		}
	}
	
	$('body').on('click', '.mobile-button', function(event) {
		event.preventDefault();
		toggleNav($(this));
		$('.mobi-overlay').toggleClass('show');
		$('.mobile-button').toggleClass('mobile-button--open');
		$('#main-nav').toggle();
        if($('.mobile-button').hasClass('mobile-button--open')){
            $('#featured-title, #main-content, #footer').css('position', 'fixed')
        }
        else{
            $('#featured-title, #main-content, #footer').css('position', 'relative')
        }
	});
	
	$('.mobi-overlay-close').on('click', function(){
		$('#main-nav').hide();
	});
	
	subMenus();
});

if ( $('body').hasClass('header-fixed') ) {
	var nav = $('#site-header');

	if ( nav.length ) {
		var
		offsetTop = nav.offset().top,
		headerHeight = nav.height();

		if ( $('body').is('.header-style-2') ) {
			headerHeight = 0;
		}

		var injectSpace = $('<div />', {
			height: headerHeight
		}).insertAfter(nav);

		$(window).on('load scroll', function(){
			if ( $(window).scrollTop() > offsetTop ) {
				nav.addClass('fixed-hide');
				if ( ! $('body').is('.header-style-2') ) {
					injectSpace.show();
				}
			} else {
				nav.removeClass('fixed-hide');
				injectSpace.hide();
			}

			if ( $(window).scrollTop() > 500 ) {
				nav.addClass('fixed-show');
			} else {
				nav.removeClass('fixed-show');
			}
		});
	}
}  